import React from 'react';

import { useNotifications } from '../../contexts/NotificationsContext';
import { useI18n } from '../../i18n';
import { NotificationCard } from './NotificationCard';

/**
 * Manager's full notification feed, at /restaurant/notifications.
 */
export const NotificationsPage: React.FC = () => {
  const { items, unreadCount, loading, error, hasMore, refresh, loadMore, markRead, markAllRead, dismiss } = useNotifications();
  const { t } = useI18n();

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '24px 20px 80px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, margin: 0 }}>{t('notifications.title')}</h1>
        {unreadCount > 0 && (
          <span
            style={{
              background: '#3B82F6',
              color: 'white',
              padding: '4px 10px',
              borderRadius: 999,
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            {unreadCount}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ color: '#6B7280', fontSize: 14 }}>{t('notifications.subtitle')}</div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            type="button"
            onClick={() => refresh()}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3B82F6', fontWeight: 600 }}
          >
            {t('notifications.refresh')}
          </button>
          {unreadCount > 0 && (
            <button
              type="button"
              onClick={() => markAllRead()}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3B82F6', fontWeight: 600 }}
            >
              {t('notifications.markAllRead')}
            </button>
          )}
        </div>
      </div>
      {loading && items.length === 0 && <div style={{ padding: 32, textAlign: 'center', color: '#6B7280' }}>{t('notifications.loading')}</div>}
      {error && (
        <div style={{ padding: 16, background: '#FEE2E2', color: '#991B1B', borderRadius: 12, marginBottom: 12 }}>
          {t('notifications.error.title')} — {error}
          <div style={{ marginTop: 8 }}>
            <button type="button" onClick={() => refresh()} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#991B1B', textDecoration: 'underline' }}>
              {t('notifications.error.retry')}
            </button>
          </div>
        </div>
      )}
      {!loading && items.length === 0 && !error && (
        <div style={{ padding: 40, textAlign: 'center', color: '#6B7280' }}>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>{t('notifications.empty.title')}</div>
          <div style={{ fontSize: 14 }}>{t('notifications.empty.body')}</div>
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {items.map((n) => (
          <NotificationCard
            key={n.id}
            notification={n}
            onClick={() => markRead(n.id)}
            onDismiss={() => dismiss(n.id)}
          />
        ))}
      </div>
      {hasMore && (
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <button
            type="button"
            disabled={loading}
            onClick={() => loadMore()}
            style={{ background: '#3B82F6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
          >
            {loading ? '…' : 'Load more'}
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;
